<script>
import { Component, Vue } from 'vue-property-decorator'
import { infrontViewMenu } from '@/assets/js/fetch'
import Prism from '@/assets/js/prism'
import { stringDateFormat, mainUrl, apiDomain } from '@/assets/js/utils'
import Clipboard from 'clipboard'
// eslint-disable-next-line
import QrCode from './Qrcode'

Component.registerHooks(['beforeRouteUpdate'])

@Component
export default class ApiDetail extends Vue {
  render() {
    return (
      <div class="detail-main">
        <div class="hidden-up m-docs">
          <div class="m-docs-menu" onClick:stop={this.showAside}>
            <span />
            <span />
            <span />
          </div>
          {this.detailData.parent_name}·{this.detailData.name}
        </div>
        <div class="docs">
          <div class="docs-item">
            <h3 class="docs-title">
              <span class="docs-async-text">{this.detailData.name}</span>
              {this.detailData.async_state === '2' && (
                <span class="docs-async docs-async-text">异步</span>
              )}
              {this.detailData.high === '1' && (
                <span class="docs-async-high docs-async-text">高级</span>
              )}
              {this.detailData.custom === '1' && (
                <span class="docs-async-custom docs-async-text">定制</span>
              )}
            </h3>
            <p class="docs-text" domPropsInnerHTML={this.detailData.desp} />
          </div>
          <div class="docs-item">
            <h3 class="docs-title">请求方式</h3>
            <div class="docs-text">
              <p class="docs-interface-text">
                请求地址：<i>
                  {apiDomain}/api
                  {this.detailData.url}
                </i>
              </p>
              <p class="docs-interface-text">
                请求方式：{this.detailData.method}
              </p>
            </div>
          </div>
          <div class="docs-item">
            <p class="docs-title">HTTP Header</p>
            <div class="docs-header-desc">
              <div class="docs-header-desc-title">
                <p v-show={this.detailData.method === 'POST'}>Content-Type</p>
                <p>Key</p>
              </div>
              <div class="docs-header-desc-content">
                <p v-show={this.detailData.method === 'POST'}>
                  {this.detailData.content_type}
                </p>
                <p style="color: #2b6ed3;">
                  <a
                    target="_blank"
                    href={`${mainUrl}/account/user/openapi.html`}
                  >
                    你在控制台获取的Key
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div class="docs-item">
            <h3 class="docs-title">
              HTTP 请求参数<span class="docs-title-small">
                （x-www-form-urlencoded格式）
              </span>
            </h3>
            <div class="docs-body-analysis">
              <table class="docs-body-table">
                <thead>
                  <tr>
                    <th>参数</th>
                    <th>类型</th>
                    <th>是否必填</th>
                    <th>默认值</th>
                    <th>说明</th>
                    <th>示例值</th>
                  </tr>
                </thead>
                <tbody>
                  {this.detailData.request_body &&
                    JSON.parse(this.detailData.request_body).map(item => {
                      return (
                        <tr>
                          <td>{item.parameter}</td>
                          <td>{item.type}</td>
                          <td>{item.isNeed}</td>
                          <td>{`${item.value}`}</td>
                          <td>
                            <div
                              class="docs-body-table-line"
                              domPropsInnerHTML={item.desc}
                            />
                          </td>
                          <td>{`${item.exampleVlaue}`}</td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
              {this.detailData.req_comment && (
                <div class="docs-body-table-comment">
                  注：<span domPropsInnerHTML={this.detailData.req_comment} />
                </div>
              )}
            </div>
          </div>
          <div class="docs-item">
            <p class="docs-title">
              HTTP 返回 Body<span class="docs-title-small">
                &nbsp;(Json格式)
              </span>
            </p>
            <div class="docs-body-analysis">
              <table class="docs-body-table">
                <thead>
                  <tr>
                    <th>参数名</th>
                    <th>类型</th>
                    <th>说明</th>
                  </tr>
                </thead>
                <tbody>
                  {this.detailData.reponse_body &&
                    JSON.parse(this.detailData.reponse_body).map(item => {
                      return (
                        <tr ref="reqList" refInFor>
                          <td data-key={item.parameter}>{item.parameter}</td>
                          <td data-value={item.type}>{item.type}</td>
                          <td>
                            <div
                              class="docs-body-table-line"
                              domPropsInnerHTML={item.desc}
                            />
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
              {this.detailData.res_comment && (
                <div class="docs-body-table-comment">
                  注：<span domPropsInnerHTML={this.detailData.res_comment} />
                </div>
              )}
            </div>
          </div>
          <div class="docs-item">
            {this.detailData.req_example && (
              <div>
                <h3 class="docs-title">
                  HTTP请求示例
                  <el-tooltip
                    ref="copytip"
                    enterable={false}
                    manual={true}
                    content={this.copyStatus ? '复制成功' : '复制失败'}
                    placement="bottom"
                  >
                    <button
                      class="copy-request-example"
                      data-clipboard-text={this.detailData.req_example}
                      onMouseleave={this.leaveCopyButton}
                    >
                      <span class="copy-request-example-icon" />
                      <span>复制</span>
                    </button>
                  </el-tooltip>
                </h3>
                <div class="docs-code" ref="reqExample" />
              </div>
            )}
          </div>
          <div class="docs-item">
            <h3 class="docs-title">返回JSON实例</h3>
            <div class="docs-code" ref="responseJson" />
          </div>
          {this.detailData.async_state === '2' && (
            <div>
              <div class="docs-item">
                <p class="docs-title">异步任务相关接口</p>
                <div class="docs-item-content docs-item-content-async">
                  <span class="docs-item-content-async-title">
                    数据获取接口：
                  </span>
                  {
                    this.$route.params.id === '166' ? <router-link
                      to="/list/detail/167"
                      tag="p"
                      class="docs-item-content-async-url"
                    >
                      {apiDomain}/api{this.asyncData.getUrl}
                    </router-link> : <router-link
                      to="/list/detail/153"
                      tag="p"
                      class="docs-item-content-async-url"
                    >
                      {apiDomain}/api{this.asyncData.getUrl}
                    </router-link>
                  }
                </div>
                <div
                  class="docs-item-content docs-item-content-async"
                  style="display: none;"
                >
                  <span class="docs-item-content-async-title">
                    任务查询接口：
                  </span>
                  <p class="docs-item-content-async-url">
                    {this.asyncData.searchUrl}
                  </p>
                </div>
              </div>
              <div class="docs-item docs-body">
                <p class="docs-title">
                  异步任务（数据获取）HTTP 返回 Body<span class="docs-title-small">
                    &nbsp;(Json格式)
                  </span>
                </p>
                <div class="docs-body-analysis">
                  <table class="docs-body-table docs-body-table-padding">
                    <thead>
                      <tr>
                        <th width="180px">参数名</th>
                        <th width="140px">类型及范围</th>
                        <th>说明</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.asyncData.resBody.map(item => {
                        return (
                          <tr>
                            <td data-key={item.parameter}>{item.parameter}</td>
                            <td data-type={item.type}>{item.type}</td>
                            <td>
                              <div
                                class="docs-body-table-line"
                                domPropsInnerHTML={item.desc}
                              />
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  {this.asyncData.res_comment && (
                    <div class="docs-body-table-comment">
                      注：<span
                        domPropsInnerHTML={this.asyncData.res_comment}
                      />
                    </div>
                  )}
                </div>
                <p class="docs-title">异步任务（数据获取）返回Json实例</p>
                <div class="docs-code" ref="asyncResponseJson" />
                {this.asyncData.res_Json_comment && (
                  <div
                    class="docs-body-table-comment"
                    style="margin-left:12px;"
                  >
                    注：<span
                      domPropsInnerHTML={this.asyncData.res_Json_comment}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
          <div class="docs-item">
            <h3 class="docs-title">状态码说明</h3>
            <div class="docs-body-analysis">
              <table class="docs-body-table">
                <thead>
                  <tr>
                    <th width="120px">状态码</th>
                    <th>说明</th>
                  </tr>
                </thead>
                <tbody>
                  {this.detailData.status_collection &&
                    JSON.parse(this.detailData.status_collection).map(item => {
                      return (
                        <tr>
                          <td>{item.status}</td>
                          <td>{item.desc}</td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
              {this.detailData.status_comment && (
                <div class="docs-body-table-comment">
                  注：<span
                    domPropsInnerHTML={this.detailData.status_comment}
                  />
                </div>
              )}
            </div>
          </div>
          <div class="docs-item">
            <p class="docs-title">接口访问限制</p>
            <div class="docs-text">
              <p class="docs-interface-text">
                访问级别：<span class="docs-strong">
                  {this.detailData.visite_level === '1'
                    ? '普通接口'
                    : '高级接口'}
                </span>
              </p>
              <p class="docs-interface-text">
                频次限制：<span class="docs-strong">
                  {this.detailData.visite_frequency}
                </span>次/分
              </p>
              <p class="docs-interface-text">
                成功返回： {this.detailData.price}{' '}
                {this.detailData.price_model === '1' ? 'u/次' : 'u/条'}
              </p>
            </div>
          </div>
          <div class="docs-item">
            <h3 class="docs-title">其它</h3>
            <p
              class="docs-text"
              domPropsInnerHTML={
                this.detailData.comments ? this.detailData.comments : '无'
              }
            />
          </div>
          <div class="docs-updateTime">
            <p class="second-foot-time">
              文档更新时间：{stringDateFormat(
                'yyyy-MM-dd',
                this.detailData.update_time ? this.detailData.update_time : ''
              )}
            </p>
          </div>
        </div>
        <div class="rightnav hidden">
          &nbsp;<div class="rightnav-fixed">
            <div class="rightnav-fixed-nav">
              <ul class="rightnav-list">
                {this.anchor.map((item, index) => (
                  <li
                    class="rightnav-list-item"
                    {...{
                      class: [this.currentIndex === index ? 'active' : '']
                    }}
                    key={index}
                    onClick={this.selectMenu.bind(this, index)}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <QrCode />
          </div>
        </div>
      </div>
    )
  }
  anchor = [
    '接口名',
    '请求方式',
    'HTTP Header',
    'HTTP 请求参数',
    'HTTP 返回 Body',
    'HTTP请求示例',
    '返回JSON实例',
    '状态码说明',
    '接口访问限制',
    '其它'
  ]
  asyncData = {}
  detailData = {}
  heightList = []
  scrollY = 0
  isMounted = false
  isAjax = false
  copyStatus = true // 复制提示状态成功or失败
  get currentIndex() {
    for (let i = 0, len = this.heightList.length; i < len; i++) {
      const top1 = this.heightList[i]
      const top2 = this.heightList[i + 1]
      if (!top2 || (this.scrollY >= top1 && this.scrollY < top2)) {
        return i
      }
    }
    return 0
  }
  created() {
    this.getDocData()
  }
  beforeRouteUpdate(to, from, next) {
    next()
    this.getDocData()
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  }
  mounted() {
    this.isMounted = true
    if (this.isAjax) {
      this.prismUpdated()
    }
    this.$nextTick(() => {
      this.scrollListtener()
      const clipboard = new Clipboard('.copy-request-example')
      clipboard.on('success', e => {
        this.copyStatus = true
        this.$refs.copytip.showPopper = true
      })
      clipboard.on('error', () => {
        this.copyStatus = false
        this.$refs.copytip.showPopper = true
      })
    })
  }
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollCallback, false)
  }
  // 鼠标离开复制按钮隐藏tooltip
  leaveCopyButton() {
    this.$refs.copytip.showPopper = false
  }
  // 高亮代码
  prismUpdated() {
    this.$nextTick(() => {
      this.$refs.responseJson.innerHTML = `<pre class="language-json line-numbers" data-start="1"><code>${
        this.detailData.reponse_json
      }</code></pre>`
      // this.$refs.requestJson.innerHTML = `<pre class="language-json line-numbers" data-start="1"><code>${
      //   this.detailData.request_json
      // }</code></pre>`
      if (this.detailData.req_example) {
        this.$refs.reqExample.innerHTML = `<pre class="language-bash line-numbers" data-start="1"><code>${
          this.detailData.req_example
        }</code></pre>`
      }
      if (this.asyncData.resJsonData) {
        this.$refs.asyncResponseJson.innerHTML = `<pre class="language-json line-numbers" data-start="1"><code>${
          this.asyncData.resJsonData
        }</code></pre>`
      }
      Prism.highlightAll()
      this.calculateTop()
    })
  }
  getDocData() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    infrontViewMenu({
      level: '3',
      id: this.$route.params.id
    }).then(res => {
      const data = res.data.value
      this.isAjax = true
      loading.close()
      if (data) {
        this.asyncData = JSON.parse(data.async_data)
        this.detailData = data
        if (this.isMounted) {
          this.prismUpdated()
        }
      }
    })
  }
  selectMenu(index) {
    this.scrollY = this.heightList[index]
    document.body.scrollTop = this.scrollY
    document.documentElement.scrollTop = this.scrollY
  }
  calculateTop() {
    this.heightList = []
    const docs = document.querySelectorAll('.docs-item')
    let height = 0
    this.heightList.push(height)
    height = height + 75
    for (let i = 0, len = docs.length; i < len; i++) {
      const top = docs[i].clientHeight
      height += top + 45
      this.heightList.push(height)
    }
  }
  scrollListtener() {
    window.addEventListener('scroll', this.scrollCallback, false)
  }
  scrollCallback(e) {
    this.scrollY = window.pageYOffset
  }
  showAside() {
    const aside = document.querySelector('.aside')
    if (aside) {
      aside.style.display = 'block'
    }
  }
}
</script>

<style lang="postcss">
@import "../../assets/css/_pub.css";
.rightnav {
  height: 0;
  text-align: right;
  overflow: hidden;
  font-size: 14px;
  &-fixed {
    display: inline;
    position: fixed;
    margin-left: 20px;
    top: 107px;
    &-nav {
      border-left: 1px solid #d4d4d4;
      padding: 0px 0 8px 10px;
      position: relative;
      margin-bottom: 25px;
      &::after,
      &::before {
        content: "";
        height: 7px;
        width: 7px;
        position: absolute;
        border-radius: 50%;
        border: 1px solid #d4d4d4;
        left: 0;
      }
      &::before {
        top: 0;
        transform: translate(-50%, -100%);
      }
      &::after {
        bottom: 0;
        transform: translate(-50%, 100%);
      }
    }
  }
  &-list {
    margin: 0;
    padding: 0;
    list-style: none;
    text-align: left;
    line-height: 22px;
    margin-left: -11px;
    overflow: hidden;
    &-item {
      margin: 10px 0;
      cursor: pointer;
      padding-left: 10px;
      position: relative;
      &.active,
      &:hover {
        color: #2edadc;
        background-image: -webkit-gradient(
          linear,
          right top,
          left top,
          from(#26b3eb),
          to(#2edadc)
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        &::before {
          content: "";
          position: absolute;
          width: 1px;
          left: 0;
          top: 0;
          bottom: 0;
          background-image: linear-gradient(to bottom, #26b3eb, #2edadc);
        }
      }
    }
  }
}

.docs-updateTime {
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  color: #999;
}
.copy-request-example {
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  border: 0;
  display: inline-flex;
  align-items: center;
  color: #2b6ed3;
  background: transparent;
  margin-left: 8px;
  &-icon {
    @mixin size 12px, 14px;
    background: url(~@/assets/img/copy.png) center/cover no-repeat;
    display: inline-block;
    margin-right: 5px;
  }
}
.docs-async-text {
  display: inline-block;
  vertical-align: middle;
}
.docs-async,
.docs-async-high,
.docs-async-custom {
  font-size: 12px;
  color: #fff;
  margin-left: 15px;
  font-weight: normal;
  padding: 4px 20px;
  line-height: 1;
  background: linear-gradient(90deg, #25b3eb, #2edadc);
  border-radius: 10px 0 10px 0;
}
.docs-async-high {
  background: linear-gradient(180deg, #edd7a2, #e6b245);
}
.docs-async-custom {
  background: linear-gradient(-90deg, #c7d4d4, #8491a2);
}
.detail-main {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/public/ApiDetail.vue